export const ADMIN_BROWSE_SECTION_TYPE = {
  CATALOG_TITLES: 'catalog-titles',
  LINKS: 'links',
  LISTS: 'lists',
  LISTS_HERO: 'lists-hero',
  LIST_TITLES: 'list-titles',
  NAVIGATION: 'navigation'
};

export const BROWSE_HOME_PAGE_SCHEMA_VERSION = '1.3.0';

export const BROWSE_HOME_PAGE_STATUS = {
  ACTIVE: 'active',
  DRAFT: 'draft',
  UNKNOWN: 'unknown'
};

export const DEFAULT_LINK_VALIDATION = {
  isValid: true,
  errorByAttribute: {
    label: '',
    url: ''
  }
};

export const LISTS_NUM_MIN_LIST_URLS = 2;
export const LISTS_NUM_MAX_LIST_URLS = 4;

export const LISTS_HERO_NUM_MIN_LIST_URLS = 3;
export const LISTS_HERO_NUM_MAX_LIST_URLS = 5;

export const NUM_MAX_LINKS = 12;

export const VALIDATION_ERROR_MESSAGE = {
  DUPLICATE_LIST_URL: 'List already exists in this row. Add a new List URL.',
  INVALID_CATALOG_SEARCH_URL: 'A catalog search URL is required',
  INVALID_HEADING: 'A heading is required',
  INVALID_LABEL: 'A label is required',
  INVALID_LIST_URL: 'A List URL is required',
  INVALID_URL: 'A URL is required'
};
